import { useUpdateJobDraftMutation } from "@js/apps/jobs/api";

const FIXED_CACHE_MUTATION_KEY = "saving-job-draft";

export const useJobFormUpdateJobDraftMutation = () => {
  return useUpdateJobDraftMutation({ fixedCacheKey: FIXED_CACHE_MUTATION_KEY });
};
